import { render, staticRenderFns } from "./manage-activity-groups.vue?vue&type=template&id=472d726a"
import script from "./manage-activity-groups.vue?vue&type=script&lang=js"
export * from "./manage-activity-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports